<script lang="ts">
	import { derived, writable, get } from 'svelte/store';
	import ReportsLoading from '../../../../../shared/components/common/Loading/ReportsLoading.svelte';
	import LocaleSelector from '../../../../../shared/components/common/LocaleSelector.svelte';
	import NoDataAvailable from '../../../../../shared/components/common/NoDataAvailable.svelte';
	import SurveyReport from '../../../../../shared/components/common/Survey/SurveyReport.svelte';
	import FiltroGenerico from '../../../../../shared/models/Filtri/FiltroGenerico';
	import Questionario from '../../../../../shared/models/Questionario/Questionario';
	import QuestionarioRisposte from '../../../../../shared/models/Questionario/QuestionarioRisposte';
	import { locale, setupI18n } from '../../../../../shared/services/i18n';
	import Sede from '../../../../../shared/models/Sede/Sede';
	import AziendaEnte from '../../../../../shared/models/AziendaEnte/AziendaEnte';
	import Checkbox from '@smui/checkbox';
	import Button, { Label } from '@smui/button';
	import IconButton, { Icon } from '@smui/icon-button';
	import Accordion, { Content, Header, Panel } from '@smui-extra/accordion';
	import FieldLoading from '../../../../../shared/components/common/Loading/FieldLoading.svelte';
	import { onMount, onDestroy, tick } from 'svelte';
	import ExpandIcon from '../../../../../shared/components/common/Icons/ExpandIcon.svelte';
	import ProgressLoading from '../../../../../shared/components/common/Loading/ProgressLoading.svelte';
	import { formatPercentageWithComma } from '../../../../../shared/functions';
	
	console.log('🚀 QuestionariSediReport - Component initialized');
	
	window.localStorage.removeItem('aziendeRispondentiId');
	window.localStorage.removeItem('questionariAziendeReportId');

	let stringifiedQuestionarioJson = '';
	let stringifiedQuestionarioJsonUpdated = '';
	let risposteJson = [];
	let risposteJsonUpdated = [];
	let showReport = true;
	let accordionOpen = true; 

	let aziende = [];
	let loading_aziende = writable(false);
	let expandedAziende = {}; 

	let questionariId: number[] = localStorage.getItem('questionariSediReportId') !== null ? JSON.parse(localStorage.getItem('questionariSediReportId')) : [];
	let sediRispondentiId: number[] = localStorage.getItem('sediRispondentiId') !== null ? JSON.parse(localStorage.getItem('sediRispondentiId')) : [];

	let availableSediConRisposte = [];
	let loading_sedi = writable(false);
	let sediRisposteByAzienda = {}; 
	
	let selectedSediIds = [...sediRispondentiId];

	let [data, loading, error] = Questionario.merge(questionariId);
	
	let isLoading = writable(true);
	
	// Flag per evitare caricamenti multipli
	let reportLoadingStarted = false;
	
	let currentFilters = {
		questionariId: [...questionariId],
		sediId: [...selectedSediIds],
	};
	
	let subscriptions = [];
	
	function unsubscribeAll() {
		subscriptions.forEach(unsub => {
			if (typeof unsub === 'function') {
				unsub();
			}
		});
		subscriptions = [];
	}
	
	function loadSediConRisposteAndAziende() {
		loading_sedi.set(true);
		loading_aziende.set(true);
		
		// Timeout di sicurezza per evitare loading infinito
		const timeoutId = setTimeout(() => {
			console.log('⏰ QuestionariSediReport - Timeout reached, forcing loading to false');
			loading_sedi.set(false);
			loading_aziende.set(false);
			// Se non ci sono sedi, carica comunque i dati del report se abbiamo il questionario
			if (stringifiedQuestionarioJson && !reportLoadingStarted) {
				console.log('🔄 QuestionariSediReport - Loading report data after timeout');
				reportLoadingStarted = true;
				loadAndPrepareReportData();
			}
		}, 10000); // 10 secondi
		
		const sediRisposteFilter = {
			questionariId: questionariId,
			sediId: sediRispondentiId
		};
		
		const [dataSediConRisposte, loadingSediConRisposte, errorSediConRisposte] = Questionario.getListSediConRisposteWithFilters(sediRisposteFilter);
		const [dataAziende, loadingAziende, errorAziende] = AziendaEnte.getList();
		
		const sediSubscription = dataSediConRisposte.subscribe(value => {
			console.log('📦 QuestionariSediReport - Sedi con risposte data received:', value);
			console.log('📦 QuestionariSediReport - Value type:', typeof value, 'Array?', Array.isArray(value));
			
			let sediRisposteData = null;
			
			// Gestisci diversi formati di risposta
			if (value && value.response && Array.isArray(value.response)) {
				console.log('📦 QuestionariSediReport - Using value.response format');
				sediRisposteData = value.response;
			} else if (Array.isArray(value)) {
				console.log('📦 QuestionariSediReport - Using direct array format');
				sediRisposteData = value;
			} else if (value && Array.isArray(value.data)) {
				console.log('📦 QuestionariSediReport - Using value.data format');
				sediRisposteData = value.data;
			}
			
			console.log('📦 QuestionariSediReport - Processed sediRisposteData:', sediRisposteData);
			
			if (sediRisposteData && sediRisposteData.length > 0) {
				clearTimeout(timeoutId); // Cancella il timeout
				availableSediConRisposte = sediRisposteData;
				sediRisposteByAzienda = groupSediRisposteByAzienda(availableSediConRisposte);
				loading_sedi.set(false);
				
				console.log('✅ QuestionariSediReport - Sedi con risposte loaded:', {
					availableSediConRisposte: availableSediConRisposte.length,
					sediRisposteByAzienda: Object.keys(sediRisposteByAzienda).length
				});
			} else {
				console.log('⚠️ QuestionariSediReport - No valid sedi data found');
				clearTimeout(timeoutId); // Cancella il timeout
				loading_sedi.set(false);
				availableSediConRisposte = [];
				sediRisposteByAzienda = {};
			}
		});
		
		const aziendeSubscription = dataAziende.subscribe(value => {
			console.log('📦 QuestionariSediReport - Aziende data received:', value);
			if (value && value.response) {
				aziende = value.response;
				loading_aziende.set(false);
				console.log('✅ QuestionariSediReport - Aziende loaded:', aziende.length);
			} else {
				console.log('⚠️ QuestionariSediReport - No valid aziende data found');
				loading_aziende.set(false);
				aziende = [];
			}
		});
		
		subscriptions.push(sediSubscription, aziendeSubscription);
	}
	
	function groupSediRisposteByAzienda(sediConRisposte) {
		console.log('🏗️ QuestionariSediReport - Grouping sedi by azienda:', sediConRisposte.length);
		const grouped = {};
		
		if (!sediConRisposte || sediConRisposte.length === 0) {
			console.log('⚠️ QuestionariSediReport - No sedi to group');
			return grouped;
		}
		
		sediConRisposte.forEach(sedeRisposta => {
			if (sedeRisposta.sede && sedeRisposta.sede.aziendaEnteId) {
				if (!grouped[sedeRisposta.sede.aziendaEnteId]) {
					grouped[sedeRisposta.sede.aziendaEnteId] = [];
				}
				grouped[sedeRisposta.sede.aziendaEnteId].push(sedeRisposta);
			}
		});
		
		console.log('✅ QuestionariSediReport - Grouped sedi by azienda:', Object.keys(grouped).length, 'aziende');
		return grouped;
	}
	
	function getAziendaName(aziendaId) {
		const azienda = aziende.find(a => a.id === aziendaId);
		return azienda ? azienda.nomeAziendaEnte : 'Azienda/Ente sconosciuto';
	}
	
	function toggleAzienda(aziendaId) {
		expandedAziende[aziendaId] = !expandedAziende[aziendaId];
		expandedAziende = {...expandedAziende};
	}
	
	function areAllSediSelected(aziendaId) {
		const sediRisposte = sediRisposteByAzienda[aziendaId] || [];
		if (sediRisposte.length === 0) return false;
		
		return sediRisposte.every(sedeRisposta => selectedSediIds.includes(sedeRisposta.sede.id));
	}
	
	function areSomeSediSelected(aziendaId) {
		const sediRisposte = sediRisposteByAzienda[aziendaId] || [];
		return sediRisposte.some(sedeRisposta => selectedSediIds.includes(sedeRisposta.sede.id)) && !areAllSediSelected(aziendaId);
	}
	
	function toggleSelectAllSediOfAzienda(aziendaId, select) {
		const sediRisposte = sediRisposteByAzienda[aziendaId] || [];
		
		if (select) {
			const sediIds = sediRisposte.map(sedeRisposta => sedeRisposta.sede.id);
			selectedSediIds = [...new Set([...selectedSediIds, ...sediIds])];
		} else {
			selectedSediIds = selectedSediIds.filter(id => !sediRisposte.some(sedeRisposta => sedeRisposta.sede.id === id));
		}
	}
	
	function loadAndPrepareReportData() {
		console.log('📊 QuestionariSediReport - loadAndPrepareReportData called');
		
		// Evita caricamenti multipli
		if (reportLoadingStarted) {
			console.log('⚠️ QuestionariSediReport - Loading already started, skipping');
			return;
		}
		
		reportLoadingStarted = true;
		isLoading.set(true);
		
		const [dataRisposte, loadingRisposte, errorRisposte] = QuestionarioRisposte.getList(currentFilters);
		
		const loadingSubscription = loadingRisposte.subscribe(loading => {
			console.log('loadingRisposte:', loading);
			if (!loading) {
				setTimeout(() => { 
					isLoading.set(loading);
				}, 500);
			} else {
				isLoading.set(loading);
			}
		});
		
		const risposteSubscription = dataRisposte.subscribe(async value => {
			if (value && value.response) {
				
				const parsed = value.response
					.filter(risposta => risposta && risposta.questionarioRisposteJson)
					.map(risposta => {
						try {
							return JSON.parse(risposta.questionarioRisposteJson);
						} catch (e) {
							return null;
						}
					})
					.filter(item => item !== null);
				
				risposteJson = parsed;
				
				if (stringifiedQuestionarioJson && parsed.length > 0) {
					prepareReportData(stringifiedQuestionarioJson, parsed);
				} else {
					showReport = false;
					risposteJsonUpdated = [];
					
					await tick();
					
					showReport = true;
					isLoading.set(false);
				}
			} else {
				risposteJson = [];
				risposteJsonUpdated = []; 
				showReport = false;
				await tick();
				showReport = true;
				isLoading.set(false);
			}
		});
		
		subscriptions.push(loadingSubscription, risposteSubscription);
	}
	
	async function prepareReportData(questionarioString, risposteArray) {
		isLoading.set(true);
		
		const [reportData, reportLoading, reportError] = Questionario.prepareSurveyForGraphicReports(
			questionarioString,
			JSON.stringify(risposteArray)
		);
		
		const loadingSubscription = reportLoading.subscribe(loading => {
			isLoading.set(loading);
		});
		
		const dataSubscription = reportData.subscribe(async value => {
			if (value && value.response) {
				
				showReport = false;
				
				if (value.response.questionarioJsonStringified) {
					stringifiedQuestionarioJsonUpdated = value.response.questionarioJsonStringified;
				}
				
				if (value.response.risposte) {
					risposteJsonUpdated = [...value.response.risposte];
				}
				
				await tick();
				
				showReport = true;
			} else {
			}
		});
		
		const errorSubscription = reportError.subscribe(err => {
			if (err) {
				isLoading.set(false);
			}
		});
		
		subscriptions.push(loadingSubscription, dataSubscription, errorSubscription);
	}
	
	function updateSelectedSedi() {
		console.log('🔄 QuestionariSediReport - updateSelectedSedi called, selectedSediIds:', selectedSediIds);
		isLoading.set(true);
		reportLoadingStarted = false; // Reset del flag per permettere nuovo caricamento
		currentFilters = {
			...currentFilters,
			sediId: [...selectedSediIds]
		};
		
		unsubscribeAll();
		
		loadAndPrepareReportData();
	}
	
	function toggleSelectAllSedi(select) {
		if (select) {
			selectedSediIds = availableSediConRisposte.map(sedeRisposta => sedeRisposta.sede.id);
		} else {
			selectedSediIds = [];
		}
		
		selectedSediIds = [...selectedSediIds];
	}
	
	const questionarioSubscription = data.subscribe(value => {
		console.log('📥 QuestionariSediReport - Questionario data received:', !!value);
		if (value) {
			stringifiedQuestionarioJson = value;
			
			// Carica i dati solo se non è già in corso un caricamento
			if (!get(isLoading) && !reportLoadingStarted) {
				console.log('🔄 QuestionariSediReport - Auto-loading report data');
				loadAndPrepareReportData();
			}
		}
	});
	
	subscriptions.push(questionarioSubscription);
	
	onMount(() => {
		console.log('🏗️ QuestionariSediReport - Component mounted');
		loadSediConRisposteAndAziende();
		
		// Carica i dati del report solo se abbiamo già il questionario e non è già in corso
		if (stringifiedQuestionarioJson && !reportLoadingStarted) {
			console.log('🔄 QuestionariSediReport - Auto-loading on mount');
			loadAndPrepareReportData();
		}
	});
	
	onDestroy(() => {
		console.log('💥 QuestionariSediReport - Component destroyed');
		unsubscribeAll();
		reportLoadingStarted = false; // Reset del flag
	});

	$: {
		console.log('🔄 QuestionariSediReport - Reactive statement:', {
			isLoading: $isLoading, 
			loading: $loading, 
			reportLoadingStarted,
			hasQuestionarioJson: !!stringifiedQuestionarioJson,
			sediCount: availableSediConRisposte.length
		});
	}
</script>

<Accordion>
	<Panel square variant="outlined" color="primary" extend bind:open={accordionOpen}>
		<Header>
			Filtra per sede
			<IconButton slot="icon" toggle pressed={accordionOpen}>
				<Icon class="material-icons" on>unfold_less</Icon>
				<Icon class="material-icons">unfold_more</Icon>
			</IconButton>
		</Header>
		<Content>
			{#if $loading_sedi || $loading_aziende}
				<FieldLoading />
			{:else if Object.keys(sediRisposteByAzienda).length === 0}
				<p>Nessuna sede disponibile</p>
			{:else}
				<div class="flex justify-end mb-4">
					<Button
						on:click="{updateSelectedSedi}"
						type="button"
						variant="raised"
						class="w-auto ml-4"
					>
						<Label class="text-sm">Aggiorna report</Label>
					</Button>
				</div>
				
				<div class="max-h-96 overflow-auto">
					<table class="min-w-full p-0 m-0 text-sm leading-10 border-t-4 border-collapse border-black table-auto">
						<thead>
							<tr class="p-1">
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"></th>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">Azienda/Ente</th>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">Sedi disponibili</th>
								<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
									<Checkbox 
										checked={availableSediConRisposte.length > 0 && selectedSediIds.length === availableSediConRisposte.length}
										indeterminate={selectedSediIds.length > 0 && selectedSediIds.length < availableSediConRisposte.length}
										on:change={(e) => toggleSelectAllSedi(e.target.checked)}
									/>
								</th>
							</tr>
						</thead>
						<tbody>
							{#each Object.keys(sediRisposteByAzienda) as aziendaId}
								{@const aziendaSediRisposte = sediRisposteByAzienda[aziendaId] || []}
								<tr class="odd:bg-white even:bg-gray-50 hover:bg-gray-50 p-1">
									<td class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
										<ExpandIcon 
											condition={expandedAziende[aziendaId]} 
											onClick={() => toggleAzienda(aziendaId)}
										/>
									</td>
									<td class="border-b p-2.5 text-left leading-5">{getAziendaName(Number(aziendaId))}</td>
									<td class="border-b p-2.5 text-center leading-5">{aziendaSediRisposte.length}</td>
									<td class="border-b p-2.5 text-center leading-5">
										<Checkbox 
											checked={areAllSediSelected(aziendaId)}
											indeterminate={areSomeSediSelected(aziendaId)}
											on:change={(e) => toggleSelectAllSediOfAzienda(aziendaId, e.target.checked)}
										/>
									</td>
								</tr>
								
								{#if expandedAziende[aziendaId]}
									<tr>
										<td colspan="4" class="p-0 border">
											<div class="max-h-64 overflow-auto">
												<table class="min-w-full p-0 m-0 text-sm leading-10 table-auto">
													<thead>
														<tr class="p-1 bg-gray-100">
															<th scope="col" class="pl-8 text-xs leading-6 tracking-wider text-left border">Denominazione</th>
															<th scope="col" class="text-xs leading-6 tracking-wider text-center border">Risposte ricevute</th>
															<th scope="col" class="text-xs leading-6 tracking-wider text-center border">Percentuale risposte</th>
															<th scope="col" class="text-xs leading-6 tracking-wider text-center border">Seleziona</th>
														</tr>
													</thead>
													<tbody>
														{#each aziendaSediRisposte as sedeRisposta}
															<tr class="odd:bg-white even:bg-gray-50">
																<td class="pl-8 leading-5 text-left border">{sedeRisposta.sede?.denominazione ?? ''}</td>
																<td class="leading-5 text-center border">
																	{sedeRisposta.numeroRisposteRicevute} / {sedeRisposta.numeroTotaleLavoratori}
																</td>
																<td class="leading-5 text-center border">
																	{formatPercentageWithComma(sedeRisposta.percentualeRisposte)}%
																</td>
																<td class="leading-5 text-center border">
																	<Checkbox
																		checked={selectedSediIds.includes(sedeRisposta.sede.id)}
																		on:change={(e) => {
																			if (e.target.checked) {
																				selectedSediIds = [...selectedSediIds, sedeRisposta.sede.id];
																			} else {
																				selectedSediIds = selectedSediIds.filter(id => id !== sedeRisposta.sede.id);
																			}
																		}}
																	/>
																</td>
															</tr>
														{/each}
													</tbody>
												</table>
											</div>
										</td>
									</tr>
								{/if}
							{/each}
						</tbody>
					</table>
				</div>
				
				<div class="flex items-center justify-between mt-4">
					<span class="text-sm text-gray-600">
						{selectedSediIds.length} sedi selezionate su {availableSediConRisposte.length} disponibili
					</span>
				</div>
			{/if}
		</Content>
	</Panel>
</Accordion>

{#if Boolean($isLoading) === true || Boolean($loading) === true}
    	<!--<ReportsLoading />-->
	<ProgressLoading />
{:else if !showReport || !stringifiedQuestionarioJsonUpdated || risposteJsonUpdated?.length === 0}
    <div class="p-4">
        <NoDataAvailable />
    </div>
{:else}
    <div class="text-end pb-4">
        <LocaleSelector value="{$locale}" on:locale-changed="{(e) => setupI18n({ withLocale: e.detail })}" />
    </div>
    <SurveyReport 
        stringifiedQuestionarioJson={stringifiedQuestionarioJsonUpdated} 
        risposteJson={risposteJsonUpdated} 
    />
{/if}